<template>
  <div style="padding: 20px">
    <Row :gutter="20" style="height: 150px;">
      <Col span="18" style="height: 100%">
        <block1></block1>
      </Col>
      <Col span="6">
      <block8></block8>
      </Col>
    </Row>

    <Row :gutter="20" style="height: 280px; margin-top: 20px">
      <Col span="18" style="height: 100%"> <block2></block2> </Col
      ><Col span="6" style="height: 100%">
        <block3></block3>
      </Col>
    </Row>
    <Row :gutter="20" style="height: 300px; margin-top: 20px">
      <Col span="6" style="height: 100%">
        <block4></block4>
      </Col>
      <Col span="6" style="height: 100%">
        <block5></block5>
      </Col>
      <Col span="6" style="height: 100%">
        <block7></block7>
      </Col>
      <Col span="6" style="height: 100%">
        <block6></block6>
      </Col>
    </Row>
  </div>
</template>
<script>
import block1 from "./block1.vue";
import block2 from "./block2.vue";
import block3 from "../block3.vue";
import block4 from "../block4.vue";
import block5 from "../block5.vue";
import block6 from "../block6.vue";
import block7 from "../block7.vue";
import block8 from "../block8.vue";
export default {
  components: {
    block1,
    block2,
    block3,
    block4,
    block5,
    block6,
    block7,
    block8,
  },
};
</script>
<style>
.deskblock {
  width: 100%;
  height: 100%;
  background: white;
  padding: 20px;
  box-shadow: 2px 2px 4px #ccc;
}
.deskblock h3 {
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/gendan/index.vue